import React from "react";
import { User } from "@supabase/supabase-js";
import { Button } from "@/components/ui/button";
import { Building, PlusCircle } from "lucide-react";
import { Link } from "react-router-dom";

interface OwnerDashboardHeaderProps {
  user: User | null;
}

export function OwnerDashboardHeader({ user }: OwnerDashboardHeaderProps) {
  return (
    <div className="mb-8">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-4 gap-4">
        <div>
          <h1 className="text-2xl font-bold tracking-tight mb-1">Nursing Home Owner Dashboard</h1>
          <p className="text-muted-foreground">
            Welcome back, {user?.user_metadata?.first_name || 'Owner'}. Manage your nursing home profiles here.
          </p>
        </div>
        <Button asChild className="bg-grandpal-green-dark hover:bg-grandpal-green-darkHover shrink-0">
          <Link to="/owner/claim">
            <PlusCircle className="h-4 w-4 mr-2" />
            Claim a nursing home
          </Link>
        </Button>
      </div>
      <div className="p-4 bg-amber-50 border border-amber-200 rounded-lg">
        <div className="flex gap-3 items-center">
          <Building className="h-5 w-5 text-amber-700" />
          <div>
            <h3 className="font-medium text-amber-900">Manage Your Nursing Home Profiles</h3>
            <p className="text-sm text-amber-700">
              As a verified owner, you can view and manage your nursing home profiles. 
              Soon you'll be able to edit details, respond to inquiries, and access analytics.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
